<template>
  <hypto-popup :title="'2 Factor Authentication (Account)'" :css="'width-lg'">
    <template v-slot:body>
      <p>Are you sure you want to <b>{{tfaValue ? 'enable' : 'disable'}} 2 Factor Authentication</b> access to all users of account?</p>
      <p v-if="tfaValue">When you click confirm, all users in your account who have not enabled 2FA will be logged out from their Hypto accounts. They will be then asked to link their accounts to the Google authenticator app on their mobile devices. They will not be able to login without the OTP from Google authenticator app.</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="toggleAction">{{tfaValue ? 'Confirm and logout all users' : 'Confirm'}}</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/accountSettings'
import { mapMutations } from 'vuex'

export default {
  name: 'Account2FA',
  components: { HyptoPopup },
  props: {
    tfaValue: Boolean
  },
  methods: {
    ...mapMutations(['SET_USER_LOGGED_IN']),
    toggleAction () {
      this.tfaValue ? this.enable2FA() : this.disable2FA()
    },
    enable2FA () {
      ApiServices.enable2FA().then(response => {
        this.handleResponse(response, true)

        if (response.data && response.data.force_logout) {
          this.SET_USER_LOGGED_IN(false)
        }
      })
    },
    disable2FA () {
      ApiServices.disable2FA().then(response => {
        this.handleResponse(response)
      })
    },
    handleResponse (response, isPublic) {
      if (response.success) {
        this.successToastMsg(response.message, {isPublic})
        this.$emit('refreshTFA')
      } else {
        this.errorToastMsg(response.message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
    text-align: center;

    &:nth-child(2) {
      margin-top: 10px;
    }
  }

  .mobile {
    p {
      text-align: left !important;
    }
  }
</style>
